export default "__VITE_ASSET__XzxgUkyC__"